// test2116
(2116 && 0);
